module.exports = __webpack_public_path__ + "static/GB1Cert-371767b2a38fd0111025b1b81ccc877c.svg";